"use client";

import type { QueueContentType } from "../../../../lib/types/enums/queue/queueContentTypeEnum";
import type { QueuePosition } from "../../../../lib/types/enums/queue/queuePositionEnum";
import type { queueSchema } from "../../../../lib/types/schema/queue/queueSchema";
import type { UseRequestProps } from "../../../../request/hooks/useRequest";
import { useRequestMutation } from "../../../../request/hooks/useRequestMutation";

export type UseRequestQueueItemsProps = UseRequestProps;

export const useRequestQueueItems = ({
  ...props
}: UseRequestQueueItemsProps = {}) => ({
  mutatePost: useRequestMutation<
    typeof queueSchema,
    {
      content: {
        content_id: number;
        content_type: QueueContentType;
      };
      queue_position: QueuePosition;
    }
  >({
    ...props,
    mutationFnRequestProps: (data) => ({
      body: JSON.stringify(data),
      method: "POST",
      urlBackendPath: "/queue/items",
    }),
  }),
});
